var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projectManage"},[_c('TagsCloud',{ref:"cloudtage",on:{"cloudTages":_vm.cloudTages}}),(_vm.margintap == 0)?_c('ProjectList',{attrs:{"files":_vm.files},on:{"rowdata":_vm.rowdata}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }